"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _getAddonValue = _interopRequireDefault(require("../utils/getAddonValue"));

require("../styles/_included-addons.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var BURN_IN_CAPTIONS = 'BURN_IN_CAPTIONS';
var SRT_CAPTIONS = 'SRT_CAPTIONS';

function getAddonsByValues(addonConstants, includedAddonTypes) {
  var addons = Object.keys(addonConstants).reduce(function (includedAddons, key) {
    if (!Array.isArray(addonConstants[key])) {
      return includedAddons;
    }

    var included = addonConstants[key].filter(function (_ref) {
      var value = _ref.value;
      return includedAddonTypes.includes((0, _getAddonValue.default)(key, value));
    });
    return [].concat(_toConsumableArray(includedAddons), _toConsumableArray(included));
  }, []);
  return addons;
}

function IncludedAddons(_ref2) {
  var _objectSpread2;

  var addonConstants = _ref2.addonConstants,
      includedAddonTypes = _ref2.includedAddonTypes;

  if (!includedAddonTypes || !includedAddonTypes.length) {
    return null;
  }

  var ADDONS = _objectSpread(_objectSpread({}, addonConstants), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, BURN_IN_CAPTIONS, addonConstants.CAPTIONS(BURN_IN_CAPTIONS)), _defineProperty(_objectSpread2, SRT_CAPTIONS, addonConstants.CAPTIONS(SRT_CAPTIONS)), _objectSpread2));

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "included-addons"
  }, getAddonsByValues(ADDONS, includedAddonTypes).map(function (_ref3) {
    var label = _ref3.label,
        value = _ref3.value,
        prefix = _ref3.prefix,
        icon = _ref3.icon;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: value,
      className: "included-addons__addon-item"
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
      name: prefix || icon,
      color: "black"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "included-addons__addon-item__label"
    }, label));
  }));
}

var _default = (0, _react.memo)(IncludedAddons);

exports.default = _default;